import React, { Component } from "react";
import scopeCss, { PANEL_FROM_MODAL } from './utils/scopeCss';

import {Button, Spinner, Table} from "react-bootstrap";
import EnsResolver from "ens-resolver";

import "./App.css";
import Grid from "./components/Grid/Grid";
import PlatformNavbar from "./components/PlatformNavbar";
import MuseumExhibition from './components/Museum/MuseumExhibition';
import ChainModal from "./components/ChainModal";
import AboutPlatformModal from "./components/AboutPlatformModal";
import ProjectCreationModal from "./components/ProjectCreationModal";
import SelectProjectModal from "./components/SelectProjectModal";
import ProjectModal from "./components/ProjectModal";
import MintModal from "./components/MintModal";
import MintSuccessModal from "./components/MintSuccessModal";
import WalletModal from "./components/WalletModal";
import WizardModal from "./components/WizardModal";
import ProjectAdminModal from "./components/ProjectAdminModal";
import AdminModal from "./components/AdminModal";
import ZoraModal from "./components/Zora/ZoraModal";
import platformConfig from './config/platformConfig';
import BlockchainWriteProvider from './services/BlockchainWriteProvider';
import { createDataProvider } from './services/providerFactory';
import { getAbbreviatedHash } from './utils/formatting';
import artworkControlProfile from './utils/artworkControlProfile';
import HashDisplay from './components/HashDisplay/HashDisplay';
import DataContext from './contexts/DataContext';
import ConnectionContext from './contexts/ConnectionContext';
import WriteContext from './contexts/WriteContext';
// Gateway helpers for the project CID link below; project CSS is fetched by
// BlockchainProvider now, so fetchCSSFromIPFS is no longer imported here.
import { parseIPFSUrl, ipfsToGatewayUrl } from './utils/ipfs';

import 'bootstrap/dist/css/bootstrap.min.css';

class App extends Component {

  constructor(props) {
    super(props);

    this.dataProvider = null;
    this.writeProvider = null;
    this.museumRef = React.createRef();

    this.state = {
      contract: null,
      sourceType: 'blockchain',
      cacheGeneratedAt: null,

      // optional metadata server
      immutablesWEB: "",
      immutablesURI: "",
      useMetadataServer: true,

      // user permissions
      userIsAdmin: false,
      userIsAuthorizedArtist: false,
      userIsContractOwner: false,
      userIsPayee: false,
      contractOwner: null,
      contractBalance: 0,
      contractBalanceWei: 0,
      teammembers: null,
      authorizedArtists: null,
      userHasAProject: null,
      isConnectedToADeployedToNetwork: false,

      // curator and beneficiary
      curator: null,
      curatorPercent: null,
      beneficiary: null,
      beneficiaryPercent: null,
      artistPercent: 0,
      secondaryRoyaltyPercent: 0,

      // project and token info
      currentTokenId: 0,
      projects: [],

      projectId: null,
      featuredProjectId: null,
      projectTokens: [], // can get tokenId projectTokens[editionId-1].tokenId
      projectArtistAddress: null,
      projectIdToArtistAddress: [],
      projectPricePerEditionInWei: null,
      projectPricePerEditionInEth: null,
      projectAdditionalPayee: null,
      projectAdditionalPayeePercent: null,
      projectIsSoldOut: false,
      projectCurrentEditions: null,
      projectRoyaltyAddress: null,

      script: null,
      scriptPoster: null,
      pagePosts: [],
      warnScriptPosterArtistMismatch: false,
      warnScriptPageProjectNameMismatch: false,

      projectIdToImageURLBase: null,
      projectIdToImageURLExt: null,
      projectIdUseImageURLInGridView: null,
      clientViewImageURLInDetailView: false,
      ipfsUnavailable: false, // Set to true when IPFS gateways fail, forces P5 rendering
      missingEditions: 0, // Editions whose mint hash could not be read, so cannot be drawn

      // selected edition information
      tokenId: null,
      editionId: null,
      ownerOfSelectedEdition: null,
      ownerAsOf: null,
      editionIdEventHistoryData: null,
      editionIdMetadata: null,

      // for pagination
      currentPage: 1,

      // modal states
      isProjectModalOpen: false,
      isAboutPlatformOpen: false,
      isProjectSelectOpen: false,
      isMintOpen: false,
      isWalletOpen: false,
      isWizardOpen: false,
      isCreateProjectOpen: false,
      isZoraModalOpen: false,
      isMuseumSettingsOpen: false,
      museumModeActive: false,

      // loading variables
      loading: true,
      projectMintLoading: false,
      adminLoading: false,
      projectAdminLoading: false,
      loadingAddMessage: false,
      loadingDescription: "",

      // start block
      fromBlock: 13789857,

      platform: { ...platformConfig },
    };

    // Generate open/close methods for all modals
    [
      ['Project', 'isProjectModalOpen'],
      ['CreateProject', 'isCreateProjectOpen'],
      ['AboutPlatform', 'isAboutPlatformOpen'],
      ['SelectProject', 'isSelectProjectOpen'],
      ['Mint', 'isMintOpen'],
      ['MintSuccess', 'isMintSuccessOpen'],
      ['Wallet', 'isWalletOpen'],
      ['Wizard', 'isWizardOpen'],
      ['Update', 'isUpdateOpen'],
      ['Rent', 'isRentOpen'],
      ['Chain', 'isChainModalOpen'],
      ['Admin', 'isAdminModalOpen'],
      ['ProjectAdmin', 'isProjectAdminModalOpen'],
      ['Zora', 'isZoraModalOpen'],
    ].forEach(([name, stateKey]) => {
      this[`open${name}Modal`] = () => this.setState({ [stateKey]: true });
      this[`close${name}Modal`] = () => this.setState({ [stateKey]: false });
    });
    // Special case: opening mint success also closes the mint modal
    this.openMintSuccessModal = () => this.setState({ isMintOpen: false, isMintSuccessOpen: true });

    this.setProjectId = this.setProjectId.bind(this);
    this.onProjectChange = this.onProjectChange.bind(this);
    this.onSubmitMint = this.onSubmitMint.bind(this);

    this.setSelectedProjectEdition = this.setSelectedProjectEdition.bind(this);
    this.setSelectedEdition = this.setSelectedEdition.bind(this);
    this.setSelectedEditionMetadata = this.setSelectedEditionMetadata.bind(this);
    this.setMetadataObject = this.setMetadataObject.bind(this);
    this.setCurrentPage = this.setCurrentPage.bind(this);

    this.resetSelectedEdition = this.resetSelectedEdition.bind(this);
    this.getEditionEventHistory = this.getEditionEventHistory.bind(this);

    this.getTeammembers = this.getTeammembers.bind(this);
    this.getAuthorizedArtists = this.getAuthorizedArtists.bind(this);

    this.artistTeamUpdateProjectPricePerToken = this.artistTeamUpdateProjectPricePerToken.bind(this);
    this.artistTeamToggleProjectIsPaused = this.artistTeamToggleProjectIsPaused.bind(this);
    this.artistTeamUpdateProjectScriptTransactionHash = this.artistTeamUpdateProjectScriptTransactionHash.bind(this);
    this.artistTeamUpdateProjectImageURLInfo = this.artistTeamUpdateProjectImageURLInfo.bind(this);

    this.artistTeamLockProjectContractOwnerUnlockProject = this.artistTeamLockProjectContractOwnerUnlockProject.bind(this);
    this.teamToggleProjectIsActive = this.teamToggleProjectIsActive.bind(this);
    this.teamUpdateFeaturedProject = this.teamUpdateFeaturedProject.bind(this);

    this.contractOwnerUpdateProjectFee = this.contractOwnerUpdateProjectFee.bind(this);
    this.contractOwnerUpdateGlobalSecondaryRoyaltyPercent = this.contractOwnerUpdateGlobalSecondaryRoyaltyPercent.bind(this);
    this.contractOwnerUpdateBeneficiaryAddressAndPercent = this.contractOwnerUpdateBeneficiaryAddressAndPercent.bind(this);

    this.artistOwnerUpdateTokenWithMessage = this.artistOwnerUpdateTokenWithMessage.bind(this);

    this.getAbbreviatedHash = getAbbreviatedHash;

    this.toggleMuseumMode = this.toggleMuseumMode.bind(this);
  }

  componentDidMount = async () => {
    this.setState({loadingDescription: "please connect web3..."})
    await this.initializeProvider();
  }

  /// ===== Data Provider Functions Start ====================

  initializeProvider = async () => {
    let { dataProvider: provider, sourceType } = createDataProvider();
    this.dataProvider = provider;

    // Step 1: Connect/initialize the data source
    let initResult = await provider.initialize();

    // If blockchain fails, fall back to archive mode
    if (!initResult.success && sourceType === 'blockchain') {
      console.warn('[App] Web3 connection failed, falling back to archive mode');
      const ArchiveProvider = (await import('./services/ArchiveProvider')).default;
      provider = new ArchiveProvider({ networkId: 1, basePath: `${process.env.PUBLIC_URL}/cache/` });
      this.dataProvider = provider;
      sourceType = 'archive';
      initResult = await provider.initialize();
    }

    if (!initResult.success) {
      if (initResult.needsModal === 'metamask') {
        this.openWalletModal();
        this.setState({loading: false});
      } else if (initResult.needsModal === 'chain') {
        this.setState({
          account: initResult.accounts ? initResult.accounts[0] : null,
          loading: false, loadingDescription: ""
        });
        this.openChainModal();
      }
      return;
    }

    // Store sourceType and connection info in state
    this.setState({ sourceType, cacheGeneratedAt: provider.cacheGeneratedAt || null });

    if (initResult.contract) {
      const { web3, contract, pageContract, networkId, deployedNetwork, accounts, fromBlock } = initResult;
      this.setState({
        contract,
        pageContract,
        networkId,
        deployedNetwork,
        account: accounts[0],
        fromBlock,
        isConnectedToADeployedToNetwork: true,
      });

      // Set up write provider (blockchain only)
      if (sourceType === 'blockchain') {
        this.writeProvider = new BlockchainWriteProvider(contract, web3, () => this.state.account);
      }
    } else {
      // Non-blockchain source — mark as connected for UI purposes
      this.setState({ isConnectedToADeployedToNetwork: true, networkId: provider.networkId || 1 });
    }

    // Step 2: Get platform config
    this.setState({loadingDescription: "getting contract state..."});
    const platformState = await provider.getPlatformConfig();
    this.setState(platformState);

    // Step 3: Get user roles
    const account = this.state.account || null;
    const { userIsProjectArtist, ...roleState } = await provider.getUserRoles(account);
    this.setState(roleState);

    // Step 4: Load data
    await this.loadBlockchainData();

    // Step 5: Set up event subscriptions (blockchain only)
    if (sourceType === 'blockchain' && provider.subscribeToEvent) {
      provider.subscribeToEvent('AddressCreatedProject', {}, (error, data) => {
        if (!error) this.addNewestProjectToState(data);
      });
      provider.subscribeToEvent('AddressMintedProjectEditionAsToken',
        {projectId: this.state.projectId},
        (error, data) => {
          if (!error) this.loadProject(this.state.projectId);
        }
      );
    }

    // Step 6: Watch for account/chain changes (blockchain only)
    if (window.ethereum) {
      window.ethereum.on('accountsChanged', accounts => {
        this.setState({account: accounts[0]});
        window.location.reload();
      });
      window.ethereum.on('chainChanged', function(networkId) {
        window.location.reload();
      });
      window.ethereum.on("connect", (info) => {});
      window.ethereum.on("disconnect", (error) => {});
    }
  }

  handleWalletConnect = async (provider) => {
    try {
      await provider.request({ method: 'eth_requestAccounts' });
      window.ethereum = provider;
      const url = new URL(window.location.href);
      url.searchParams.delete('source');
      window.location.href = url.toString();
    } catch (err) {
      console.log('[App] Wallet connection failed:', err);
    }
  }

  addNewestProjectToState = async (data) => {
    const { projects, artists } = await this.dataProvider.getProjects();
    const userHasAProject = artists.includes(this.state.account);
    this.setState({ projects, projectIdToArtistAddress: artists, userHasAProject });
  }

  loadBlockchainData = async () => {
    this.setState({loading: true, loadingDescription: "getting projects..."});
    const { projects, artists } = await this.dataProvider.getProjects();
    const resolvedProjects = (projects && projects.length) ? projects : this.state.projects;

    const userHasAProject = artists.includes(this.state.account);
    this.setState({projects: resolvedProjects, projectIdToArtistAddress: artists, userHasAProject});

    if (resolvedProjects.length > 0) {
      this.setState({loadingDescription: "getting selected project..."});
      const routeProjectId = (this.props.match.params.projectId) ? parseInt(this.props.match.params.projectId, 10) : null;
      if (routeProjectId) {
        await this.loadProject(routeProjectId);
      } else if (this.state.projectId) {
        await this.loadProject(this.state.projectId);
      } else {
        await this.loadProject(this.state.featuredProjectId);
        this.openAboutPlatformModal();
      }
      this.setState({loadingDescription: "getting selected edition..."});
      const routeEditionId = (this.props.match.params.editionId) ? parseInt(this.props.match.params.editionId, 10) : null;
      if (routeEditionId) {
        await this.setSelectedEdition(routeEditionId);
      } else if (this.state.editionId) {
        await this.setSelectedEdition(this.state.editionId);
      }
    }
    this.setState({loadingDescription: "getting contract settings..."});
    await this.getAdminSettings();
    this.setState({loading: false, loadingDescription: ""});
  }

  mobileCheck = function() {
    let check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
  };

  loadProject = async (projectId) => {
    console.log("loadProject - ENTERED with projectId:", projectId);
    const projectIdNum = parseInt(projectId, 10);
    if (!projectIdNum) {
      console.log("loadProject - no projectIdNum, returning");
      return;
    }

    const projectIndex = projectIdNum - 1;
    const project = this.state.projects[projectIndex];
    console.log("loadProject - project exists:", !!project);
    if (!project) return;

    // Clear the outgoing project's stylesheet along with its posts. A project
    // themes the whole app, so leaving it set means the next project is
    // rendered in the last one's type and colours -- and if that project has no
    // style post of its own, nothing ever overwrites it. PILLARS' face was
    // following visitors onto Firmament.
    this.setState({projectId: projectIdNum, pagePosts: [], projectCSSStyle: null});

    // Get project details from provider
    const details = await this.dataProvider.getProjectDetails(projectIdNum);

    const projectCurrentEditions = project.currentEditionId;
    const projectIsSoldOut = parseInt(projectCurrentEditions) >= parseInt(project.maxEditions);
    const userIsProjectArtist = (this.state.account === details.projectArtistAddress);
    const royaltyContractArtistPercent = this.state.artistPercent;

    this.setState({
      projectArtistAddress: details.projectArtistAddress,
      projectPricePerEditionInWei: details.projectPricePerEditionInWei,
      projectPricePerEditionInEth: details.projectPricePerEditionInEth,
      projectAdditionalPayee: details.projectAdditionalPayee,
      projectAdditionalPayeePercent: details.projectAdditionalPayeePercent,
      projectIsSoldOut,
      projectCurrentEditions,
      projectRoyaltyAddress: details.projectRoyaltyAddress,
      projectIdToImageURLBase: details.projectIdToImageURLBase,
      projectIdToImageURLExt: details.projectIdToImageURLExt,
      projectIdUseImageURLInGridView: details.projectIdUseImageURLInGridView,
      clientViewImageURLInDetailView: details.clientViewImageURLInDetailView,
      royaltyContractBalance: details.royaltyContractBalance,
      royaltyContractArtistPercent,
      userIsProjectArtist
    });

    // Get script from provider
    const { script: js, poster, page, blockNumber } = await this.dataProvider.getProjectScript(project.scriptTransactionHash);

    // Grid image preferences must not hide an interactive edition's controls.
    // Only reviewed source hashes change the initial detail-view preference;
    // visitors can still choose a still image with the existing view toggle.
    const controls = js && await artworkControlProfile(js, projectIdNum);
    if (controls && controls.source === 'reviewed' && (controls.actions.length || controls.exports.length)) {
      this.setState({ clientViewImageURLInDetailView: false });
    }

    const warnScriptPosterArtistMismatch = (poster !== details.projectArtistAddress);
    const normalize = (s) => (s || '').replace(/\s+/g, '').toLowerCase();
    const warnScriptPageProjectNameMismatch = (normalize(page) !== normalize(project.name));

    // Get page posts (info, style, etc.)
    const pagePosts = await this.dataProvider.getPagePosts(page, blockNumber,
      (msg) => this.setState({ loadingDescription: msg }));
    this.setState({ pagePosts });

    // Get tokens from provider
    const tokens = await this.dataProvider.getProjectTokens(
      projectIdNum,
      projectCurrentEditions,
      (msg) => this.setState({loadingDescription: msg})
    );

    // An edition with no mint hash has no seed and cannot be rendered at all.
    // Carried through so the interface can say so, rather than quietly showing
    // a shorter grid than the project actually has.
    this.setState({
      missingEditions: this.dataProvider.missingEditionCount || 0,
      projectTokens: tokens,
      script: js,
      scriptPoster: poster,
      warnScriptPosterArtistMismatch,
      warnScriptPageProjectNameMismatch
    });

    // CSS Style. The self-hosted mirror and the IPFS copy are only caches; the
    // authoritative style is the one posted on chain to the page's style tag,
    // the same place the script comes from. So when neither cache answers, fall
    // back to the chain post rather than showing the art unthemed.
    this.setState({loadingDescription: `getting user interface style...`});
    let projectCSSStyle = await this.dataProvider.getProjectCSS(
      details.projectIdToImageURLBase,
      this.mobileCheck(),
      this.state.projectId
    );
    if (!projectCSSStyle && Array.isArray(pagePosts) && pagePosts.length) {
      // The last style post wins, so a later edit supersedes an earlier one.
      const styleTags = ['style.immutables.art', 'style'];
      let latest = null;
      for (const p of pagePosts) {
        if (styleTags.indexOf(p.tag) < 0 || !p.content) continue;
        if (!latest || (p.blockNumber || 0) >= (latest.blockNumber || 0)) latest = p;
      }
      if (latest) projectCSSStyle = latest.content;
    }
    this.setState({projectCSSStyle});
  }

  // Used by the About modal's project cards to render thumbnails from each
  // project's own script instead of an image host.
  getProjectScript = async (scriptTransactionHash) => {
    if (!this.dataProvider || !scriptTransactionHash) return null;
    return await this.dataProvider.getProjectScript(scriptTransactionHash);
  }

  getEditionEventHistory = async (editionId) => {
    return await this.dataProvider.getEditionEventHistory(editionId, this.state.projectTokens);
  }

  getAdminSettings = async () => {
    if (this.dataProvider && this.state.deployedNetwork && this.state.userIsAdmin) {
      const { contractBalance, contractBalanceWei } = await this.dataProvider.getContractBalance();
      this.setState({ contractBalance, contractBalanceWei });
    }
  }

  getTeammembers = async () => {
    this.setState({adminLoading: true});
    const teammembers = await this.dataProvider.getTeammembers();
    this.setState({adminLoading: false, teammembers});
  }

  getAuthorizedArtists = async () => {
    this.setState({adminLoading: true});
    const authorizedArtists = await this.dataProvider.getAuthorizedArtists();
    this.setState({adminLoading: false, authorizedArtists});
  }

  /// ===== Data Provider Functions End ====================

  // Modal open/close methods are generated in the constructor.

  /// ===== Modal View Hide Functions End ====================

  /// ===== Anyone Functions Start ====================

  createNewProject = (projectName, artistName, projectDescription, pricePerTokenInEth, maxEditions, scriptTransactionHash, scriptType) => {
    this.writeProvider.createNewProject(projectName, artistName, projectDescription, pricePerTokenInEth, maxEditions, scriptTransactionHash, scriptType, {
      onLoading: (loading) => this.setState({ projectCreateLoading: loading }),
      onSuccess: () => {},  // reload happens in WriteProvider
      onError: () => {},
    });
  }

  mint = (projectId) => {
    if (!this.writeProvider && this.dataProvider && this.dataProvider.mintEdition) {
      const currentMax = this.state.projects[projectId - 1]?.maxEditions;
      const token = this.dataProvider.mintEdition(currentMax != null ? parseInt(currentMax, 10) : undefined);
      if (!token) return;
      const projects = [...this.state.projects];
      const project = { ...projects[projectId - 1] };
      project.currentEditionId = token.editionId;
      projects[projectId - 1] = project;
      // mintEdition() already pushed to the internal array; create new ref for React
      const projectTokens = [...this.dataProvider._tokens];
      const projectCurrentEditions = token.editionId;
      const projectIsSoldOut = parseInt(projectCurrentEditions) >= parseInt(project.maxEditions);
      const mostRecentMintEvent = { returnValues: { projectId: String(projectId), editionId: token.editionId, tokenId: token.tokenId } };
      this.setState({ projects, projectTokens, projectCurrentEditions, projectIsSoldOut, mostRecentMintEvent }, this.openMintSuccessModal);
      return;
    }
    this.writeProvider.mint(projectId, this.state.projectPricePerEditionInWei, {
      onLoading: (loading) => this.setState({ projectMintLoading: loading }),
      onSuccess: (receipt, mostRecentMintEvent) => {
        this.setState({
          projectMintLoading: false,
          mostRecentMintEvent: mostRecentMintEvent
        }, this.openMintSuccessModal);
      },
      onError: () => {},
    });
  }

  /// ===== Anyone Functions End ====================

  /// ===== Temp Staging Start ====================

  getPlatformNavbar() {
    const { loading, contract,
            account, userIsAdmin, userHasAProject, tokenId,
            projects, projectId, projectArtistAddress, platform, projectTokens,
            editionId, ownerOfSelectedEdition, ownerAsOf, traitFilter, currentPage,
            projectIsSoldOut, deployedNetwork, projectCurrentEditions,

            projectIdToImageURLBase, projectIdToImageURLExt, clientViewImageURLInDetailView,
            ipfsUnavailable
           } = this.state;

    let navbar;
    if(projects[projectId-1]) {
        navbar = <PlatformNavbar
                contract={contract}
                loading={loading} account={account} userIsAdmin={userIsAdmin} userHasAProject={userHasAProject} 
                tokenId={tokenId} editionId={editionId} projectCurrentEditions={projectCurrentEditions} ownerOfSelectedEdition={ownerOfSelectedEdition} ownerAsOf={ownerAsOf} deployedNetwork={deployedNetwork}
                projects={projects} projectId={projectId} platform={platform} projectArtistAddress={projectArtistAddress} projectIsSoldOut={projectIsSoldOut}
                openWalletModal={this.openWalletModal} openProjectModal={this.openProjectModal} openAboutPlatformModal={this.openAboutPlatformModal} openWizardModal={this.openWizardModal}
                openMintModal={this.openMintModal} openCreateProjectModal={this.openCreateProjectModal} openZoraModal={this.openZoraModal}
                openProjectAdminModal={this.openProjectAdminModal} openAdminModal={this.openAdminModal}
                setSelectedEdition={this.setSelectedEdition} resetSelectedEdition={this.resetSelectedEdition}
                setCurrentPage={this.setCurrentPage} currentPage={currentPage}
                toggleMuseumMode={this.toggleMuseumMode} museumModeActive={this.state.museumModeActive}
                openMuseumSettings={() => this.setState({ isMuseumSettingsOpen: true })}
                sourceType={this.state.sourceType} cacheGeneratedAt={this.state.cacheGeneratedAt}
                maxGridDimension={this.getEffectiveMaxGridDimension()}
                tokens={traitFilter ? traitFilter.tokens : projectTokens}

                projectIdToImageURLBase={projectIdToImageURLBase}
                projectIdToImageURLExt={projectIdToImageURLExt}
                clientViewImageURLInDetailView={clientViewImageURLInDetailView}
                setViewImageURLInDetailView={this.setViewImageURLInDetailView}
                ipfsUnavailable={ipfsUnavailable}
                setIPFSMode={this.setIPFSMode}
                networkName={this.state.networkId === 1 ? 'Mainnet' : this.state.networkId === 4 ? 'Rinkeby' : `Network ${this.state.networkId}`}
        />
    } else {
      navbar = <PlatformNavbar
              contract={contract}
              loading={loading} account={account} userIsAdmin={userIsAdmin} userHasAProject={userHasAProject}
              tokenId={tokenId} editionId={editionId} projectCurrentEditions={projectCurrentEditions} ownerOfSelectedEdition={ownerOfSelectedEdition} ownerAsOf={ownerAsOf} deployedNetwork={deployedNetwork}
              projects={projects} projectId={projectId} platform={platform} projectArtistAddress={projectArtistAddress} projectIsSoldOut={projectIsSoldOut}
              openWalletModal={this.openWalletModal} openProjectModal={this.openProjectModal} openAboutPlatformModal={this.openAboutPlatformModal} openWizardModal={this.openWizardModal}
              openMintModal={this.openMintModal} openCreateProjectModal={this.openCreateProjectModal} openZoraModal={this.openZoraModal}
              openProjectAdminModal={this.openProjectAdminModal} openAdminModal={this.openAdminModal}
              setSelectedEdition={this.setSelectedEdition} resetSelectedEdition={this.resetSelectedEdition}
              setCurrentPage={this.setCurrentPage} currentPage={currentPage}
              toggleMuseumMode={this.toggleMuseumMode}
              openMuseumSettings={() => this.setState({ isMuseumSettingsOpen: true })}
              sourceType={this.state.sourceType} cacheGeneratedAt={this.state.cacheGeneratedAt}

              projectIdToImageURLBase={projectIdToImageURLBase}
              projectIdToImageURLExt={projectIdToImageURLExt}
              clientViewImageURLInDetailView={clientViewImageURLInDetailView}
              setViewImageURLInDetailView={this.setViewImageURLInDetailView}
              ipfsUnavailable={ipfsUnavailable}
              missingEditions={this.state.missingEditions}
              setIPFSMode={this.setIPFSMode}
              networkName={this.state.networkId === 1 ? 'Mainnet' : this.state.networkId === 4 ? 'Rinkeby' : `Network ${this.state.networkId}`}
      />
    }

    return(navbar);
  }

  getSelectedProjectInformation() {
    const { projects, projectId, projectIdToImageURLBase, projectRoyaltyAddress, projectArtistAddress, scriptPoster, platform,
      ipfsUnavailable, warnScriptPosterArtistMismatch, warnScriptPageProjectNameMismatch} = this.state;
    let scriptTransactionHash = "";
    if(projectId) {
      scriptTransactionHash = projects[projectId-1].scriptTransactionHash;
    }

    let ipfsCID = projectIdToImageURLBase;
    let ipfsCID_URL = projectIdToImageURLBase;
    try {
      // Route through the shared gateway list instead of a hardcoded host. This
      // link pointed at cloudflare-ipfs.com, which Cloudflare retired — the
      // hostname no longer resolves, so the CID link was dead for every project.
      const parsed = parseIPFSUrl(projectIdToImageURLBase);
      if(parsed) {
        ipfsCID = parsed.cid;
        ipfsCID_URL = ipfsToGatewayUrl(projectIdToImageURLBase);
      }
    } catch(e) { console.error(e) }

    return (
      <div className='selectedProjectInformation'>
      <Table striped bordered hover responsive className='editionEventHistory' size="sm">
      <tbody>
        <tr>
          <th>
            Project Name:
          </th>
          <td>
            {(projects[projectId-1]) ? (
            <a href={`http://immutables.co/#/${projects[projectId-1].name}`} target="_new">
              {projects[projectId-1].name}
              </a>) : ("")}
              {(warnScriptPageProjectNameMismatch) ? (
                <div>
                <p></p>
                <b>Caution: Immutables.co page for on-chain script does not match project name</b>
                </div>
              ) : ("")}
          </td>
        </tr>
        <tr>
          <th>
            Description:
          </th>
          <td>
            {(projects[projectId-1]) ? projects[projectId-1].description : ""}
          </td>
        </tr>
        <tr>
          <th>
            Artist Name:
          </th>
          <td>
            {(projects[projectId-1]) ? projects[projectId-1].artist : ""}
          </td>
        </tr>
        <tr>
          <th>
            Artist's Address:
          </th>
          <td>
            {projectArtistAddress ? (
              <HashDisplay value={projectArtistAddress} href={`${platform.etherscan_link}${projectArtistAddress}`} label="Artist address" />
            ) : ""}
          </td>
        </tr>
        <tr>
            <th>
              On-Chain Script:
            </th>
            <td>
              {(projects[projectId-1]) ? (
                <HashDisplay value={scriptTransactionHash} href={`${platform.etherscan_tx_link}${projects[projectId-1].scriptTransactionHash}`} label="On-chain script transaction" />
                ) : ("")}
            </td>
          </tr>
          <tr>
            <th>
              On-Chain Script Author:
            </th>
            <td>
              {scriptPoster ? (
                <HashDisplay value={scriptPoster} href={`${platform.etherscan_link}${scriptPoster}`} label="Script poster" />
              ) : ""}
              {(warnScriptPosterArtistMismatch) ? (
                <div>
                <p></p>
                <b>Caution: The on-chain script author does not match the project's artist address. This is expected if the artist's address is a custom mint manager contract. Otherwise, verify that the script was posted by the intended artist.</b>
                </div>
              ) : ("")}
            </td>
          </tr>
          <tr>
            <th>
              Script Type:
            </th>
            <td>
              {(projects[projectId-1]) ? (projects[projectId-1].scriptType) : ("")}
            </td>
          </tr>
          <tr>
            <th>
              Royalty Manager Contract:
            </th>
            <td>
              {(projects[projectId-1]) ? (
                <HashDisplay value={projectRoyaltyAddress} href={`${platform.etherscan_link}${projectRoyaltyAddress}`} label="Royalty contract" />
              ) : ("")}
            </td>
          </tr>
          <tr>
            <th>
              Marketplace Images:
            </th>
            <td>
              {(projectIdToImageURLBase) ? (
                <>
                  <HashDisplay value={ipfsCID} href={ipfsCID_URL} label="Marketplace image base" />
                  {ipfsUnavailable ? (
                    <div className="hint-generate">
                      These images aren't loading.{' '}
                      <a href={`${process.env.PUBLIC_URL}/image-generator.html?project=${projectId}`} target="_new">
                        Generate a replacement set in your browser
                      </a>.
                    </div>
                  ) : ("")}
                </>
              ) : (
                <>
                  Not set — marketplaces will show the contract's fallback SVG.{' '}
                  <a href={`${process.env.PUBLIC_URL}/image-generator.html?project=${projectId}`} target="_new">
                    Generate an image set in your browser
                  </a>.
                </>
              )}
            </td>
          </tr>
          {(projects[projectId-1]) ? (
          <tr>
            <th>
              Project Lock:
            </th>
            <td>
              {projects[projectId-1].locked
                ? <span>Locked — name, artist, max editions, script hash, and script type <u>cannot</u> be changed.</span>
                : <span>Unlocked — name, artist, max editions, script hash, and script type <u>can</u> be changed by the artist.</span>
              }
            </td>
          </tr>
          ) : ("")}
          <tr>
            <th>
              Minted:
            </th>
            <td>
              {(projects[projectId-1]) ? (`${projects[projectId-1].currentEditionId} of ${projects[projectId-1].maxEditions}`) : ("")}
            </td>
          </tr>
      </tbody>
      </Table>
      </div>
    );
  }

  /*
  getEditionEventHistoryTable() {
      let editionEventHistoryTable;
      if(window.web3) {
        editionEventHistoryTable = <EditionEventTable
          editionIdEventHistoryData={this.state.editionIdEventHistoryData}
          platform={this.state.platform}
          getAbbreviatedHash={this.getAbbreviatedHash}>
          </EditionEventTable>
      } else {
        editionEventHistoryTable = "";
      }
      return editionEventHistoryTable;
  } */

  /**
   * Say so when the grid is showing a subset.
   *
   * A filtered grid with nothing to explain it looks like missing editions, and
   * the charts that set it may since have been closed — so the way out belongs
   * here rather than only back in the dialog.
   */
  getTraitFilterNotice() {
    const { traitFilter, projectTokens } = this.state;
    if (!traitFilter) return null;
    const total = projectTokens ? projectTokens.length : 0;
    return (
      <div className="trait-filter-notice">
        <span className="font-display">
          {traitFilter.tokens.length} of {total} editions &mdash;{' '}
          {traitFilter.pairs.map(([trait, value]) => `${trait}: ${value}`).join(', ')}
        </span>
        <Button variant="outline-secondary" size="sm" className="font-display"
                style={{marginLeft: '0.6rem'}} onClick={this.clearTraitFilter}>
          show all
        </Button>
      </div>
    );
  }

  getGrid() {
    const {projects, projectId, editionId, projectTokens, script, account,
      ownerOfSelectedEdition, ownerAsOf, projectArtistAddress, traitFilter,
      editionIdEventHistoryData, userIsAdmin, loadingAddMessage, currentPage,
      projectIdToImageURLBase, projectIdToImageURLExt, projectIdUseImageURLInGridView, clientViewImageURLInDetailView,
      ipfsUnavailable, sourceType
     } = this.state;
    let grid;
    if(projects[projectId-1] && editionId == null) {
      // If the project exists and there is no selected edition show the grid.
      if(projects[projectId-1].active || account === projectArtistAddress || userIsAdmin || sourceType !== 'blockchain') {
        // User has permission.
        grid = <Grid selected={false}
        handleClick={this.setSelectedEdition}
        //projectScript={projects[projectId-1].script}
        scriptType={projects[projectId-1].scriptType}
        maxGridDimension={this.getEffectiveMaxGridDimension()}
        tokens={traitFilter ? traitFilter.tokens : projectTokens}
        script={script}
        projectIdToImageURLBase={projectIdToImageURLBase}
        projectIdToImageURLExt={projectIdToImageURLExt}
        projectIdUseImageURLInGridView={projectIdUseImageURLInGridView && !ipfsUnavailable}
        onIPFSUnavailable={this.onIPFSUnavailable}
        setSelectedEditionMetadata={this.setSelectedEditionMetadata}
        setMetadataObject={this.setMetadataObject}
        currentPage={currentPage}
        ></Grid>
      } else {
        grid = <div style={{paddingTop:'200px', margin:'0 auto', textAlign:'center'}}><h1 style={{ color: 'black'}}>not authorized</h1></div>
      }
    } else if (projects[projectId-1] && editionId !== null) {
      // If the project exists and there is a selected edition, show the selected edition.
      if(projects[projectId-1].active || account === projectArtistAddress || userIsAdmin || sourceType !== 'blockchain') {
        // User has permission.
        grid = <Grid selected={true}
        handleClick={this.resetSelectedEdition}
        //projectScript={projects[projectId-1].script}
        scriptType={projects[projectId-1].scriptType}
        tokens={projectTokens[editionId-1]}
        script={script}
        account={account}
        ownerOfSelectedEdition={ownerOfSelectedEdition} ownerAsOf={ownerAsOf}
        projectArtistAddress={projectArtistAddress}
        artistOwnerUpdateTokenWithMessage={this.artistOwnerUpdateTokenWithMessage}
        editionIdEventHistoryData={editionIdEventHistoryData}
        loadingAddMessage={loadingAddMessage}
        setSelectedEditionMetadata={this.setSelectedEditionMetadata}
        setMetadataObject={this.setMetadataObject}

        projectIdToImageURLBase={projectIdToImageURLBase}
        projectIdToImageURLExt={projectIdToImageURLExt}
        clientViewImageURLInDetailView={clientViewImageURLInDetailView && !ipfsUnavailable}
        onIPFSUnavailable={this.onIPFSUnavailable}
        ></Grid>
      } else {
        grid = <div style={{paddingTop:'200px', margin:'0 auto', textAlign:'center'}}><h1 style={{ color: 'black'}}>not authorized</h1></div>
      }
    } else {
      // There is no project, so make a message to create one.
      grid = <div style={{paddingTop:'200px', margin:'0 auto', textAlign:'center'}}><h1 style={{ color: 'black'}}>create a project</h1></div>
    }
    return grid;
  }

  /// ===== Temp Staging End ====================

  /// ===== Write Operations (delegated to WriteProvider) ====================

  _adminCallbacks = () => ({
    onLoading: (loading) => this.setState({ adminLoading: loading }),
    onSuccess: () => {},
    onError: () => {},
  })

  _projectAdminCallbacks = () => ({
    onLoading: (loading) => this.setState({ projectAdminLoading: loading }),
    onSuccess: () => {},
    onError: () => {},
  })

  contractOwnerUpdateWebsiteUrl = (newUrl) => {
    if (newUrl !== this.state.immutablesWEB)
      this.writeProvider.contractOwnerUpdateWebsiteUrl(newUrl, this._adminCallbacks());
  }
  contractOwnerUpdateAPIURL = (newUrl) => {
    if (newUrl !== this.state.immutablesURI)
      this.writeProvider.contractOwnerUpdateAPIURL(newUrl, this._adminCallbacks());
  }
  contractOwnerUpdateUseMetadataServer = (decision) => {
    this.writeProvider.contractOwnerUpdateUseMetadataServer(decision, this._adminCallbacks());
  }
  contractOwnerUpdateGlobalSecondaryRoyaltyPercent = (newRoyaltyPercent) => {
    if (newRoyaltyPercent !== this.state.secondaryRoyaltyPercent)
      this.writeProvider.contractOwnerUpdateGlobalSecondaryRoyaltyPercent(newRoyaltyPercent, {
        onLoading: (loading) => this.setState({ projectAdminLoading: loading, adminLoading: loading }),
        onSuccess: () => {}, onError: () => {},
      });
  }
  contractOwnerUpdateProjectFee = (newProjectFeeInEth) => {
    this.writeProvider.contractOwnerUpdateProjectFee(newProjectFeeInEth, this._adminCallbacks());
  }
  contractOwnerUpdateArtistPercent = (newPercent) => {
    if (newPercent !== this.state.artistPercent)
      this.writeProvider.contractOwnerUpdateArtistPercent(newPercent, this._adminCallbacks());
  }
  contractOwnerAddTeammember = (newTeammember) => {
    this.writeProvider.contractOwnerAddTeammember(newTeammember, this._adminCallbacks());
  }
  contractOwnerRemoveTeammember = (delTeammember) => {
    this.writeProvider.contractOwnerRemoveTeammember(delTeammember, this._adminCallbacks());
  }
  teamToggleArtistScreeningEnabled = () => {
    this.writeProvider.teamToggleArtistScreeningEnabled(this._adminCallbacks());
  }
  teamAddAuthorizedArtist = (newArtist) => {
    this.writeProvider.teamAddAuthorizedArtist(newArtist, this._adminCallbacks());
  }
  teamRemoveAuthorizedArtist = (delArtist) => {
    this.writeProvider.teamRemoveAuthorizedArtist(delArtist, this._adminCallbacks());
  }
  contractOwnerUpdateCuratorAddressAndPercent = (curator, percent) => {
    this.writeProvider.contractOwnerUpdateCuratorAddressAndPercent(curator, percent, this._adminCallbacks());
  }
  contractOwnerUpdateBeneficiaryAddressAndPercent = (newBeneficiary, newPercent) => {
    this.writeProvider.contractOwnerUpdateBeneficiaryAddressAndPercent(newBeneficiary, newPercent, this._adminCallbacks());
  }
  adminwithdraw = () => {
    this.writeProvider.adminwithdraw({
      onLoading: (loading) => this.setState({ adminLoading: loading }),
      onSuccess: async () => {
        await this.getAdminSettings();
        alert("Withdraw complete.");
      },
      onError: () => {},
    });
  }
  releaseRoyaltiesForProject = async (projectId) => {
    this.writeProvider.releaseRoyaltiesForProject(projectId, {
      onLoading: (loading) => this.setState({ projectAdminLoading: loading }),
      onSuccess: async () => {
        await this.loadProject(projectId);
        await this.getAdminSettings();
      },
      onError: () => {},
    });
  }

  // --- Project Admin Write Operations ---

  // In-memory project update for wizard/archive mode (no writeProvider)
  _updateProjectField = (projectId, field, value) => {
    const projects = [...this.state.projects];
    projects[projectId - 1] = { ...projects[projectId - 1], [field]: value };
    const update = { projects };
    // Recompute sold-out status when maxEditions changes
    if (field === 'maxEditions' && projectId === this.state.projectId) {
      update.projectIsSoldOut = parseInt(this.state.projectCurrentEditions) >= parseInt(value);
    }
    this.setState(update);
    // Sync back to wizardPreviewConfig in localStorage
    if (this.state.sourceType === 'wizard') {
      this._syncWizardConfig(field, value);
    }
  }

  // Map project fields to wizardPreviewConfig.details keys
  _wizardFieldMap = {
    name: 'projectName',
    artist: 'artistName',
    description: 'projectDescription',
    maxEditions: 'maxEditions',
    scriptType: 'scriptType',
  }

  _syncWizardConfig = (field, value) => {
    try {
      const stored = localStorage.getItem('wizardPreviewConfig');
      if (!stored) return;
      const config = JSON.parse(stored);
      const detailsKey = this._wizardFieldMap[field];
      if (detailsKey) {
        config.details = config.details || {};
        config.details[detailsKey] = String(value);
        if (field === 'name') config.name = String(value);
      }
      localStorage.setItem('wizardPreviewConfig', JSON.stringify(config));
    } catch (e) {
      console.warn('[App] Failed to sync wizard config:', e);
    }
  }

  _projectFieldWrite = (methodName, projectId, newValue, field, callbacksFn) => {
    const project = this.state.projects[projectId - 1];
    if (project && newValue === project[field]) return;
    if (!this.writeProvider) return this._updateProjectField(projectId, field, newValue);
    this.writeProvider[methodName](projectId, newValue, callbacksFn());
  }

  artistTeamUpdateProjectName = (projectId, v) =>
    this._projectFieldWrite('artistTeamUpdateProjectName', projectId, v, 'name', this._adminCallbacks);
  artistTeamUpdateProjectDescription = (projectId, v) =>
    this._projectFieldWrite('artistTeamUpdateProjectDescription', projectId, v, 'description', this._projectAdminCallbacks);
  artistTeamUpdateArtistName = (projectId, v) =>
    this._projectFieldWrite('artistTeamUpdateArtistName', projectId, v, 'artist', this._projectAdminCallbacks);
  artistTeamUpdateProjectPricePerToken = (projectId, newPriceInEth) => {
    if (!this.writeProvider) {
      this.setState({ projectPricePerEditionInEth: newPriceInEth });
      if (this.state.sourceType === 'wizard') {
        try {
          const stored = localStorage.getItem('wizardPreviewConfig');
          if (stored) {
            const config = JSON.parse(stored);
            config.details = config.details || {};
            config.details.pricePerToken = String(newPriceInEth);
            localStorage.setItem('wizardPreviewConfig', JSON.stringify(config));
          }
        } catch (e) { /* ignore */ }
      }
      return;
    }
    this.writeProvider.artistTeamUpdateProjectPricePerToken(projectId, newPriceInEth, this._projectAdminCallbacks());
  }
  artistTeamUpdateProjectMaxEditions = (projectId, v) =>
    this._projectFieldWrite('artistTeamUpdateProjectMaxEditions', projectId, v, 'maxEditions', this._projectAdminCallbacks);
  artistTeamUpdateProjectMaxGridDimension = (projectId, v) =>
    this._projectFieldWrite('artistTeamUpdateProjectMaxGridDimension', projectId, v, 'maxGridDimension', this._projectAdminCallbacks);
  teamToggleProjectIsActive = (projectId) => {
    if (!this.writeProvider) {
      return this._updateProjectField(projectId, 'active', !this.state.projects[projectId-1].active);
    }
    this.writeProvider.teamToggleProjectIsActive(projectId, this._projectAdminCallbacks());
  }
  artistTeamToggleProjectIsPaused = (projectId) => {
    if (!this.writeProvider) {
      return this._updateProjectField(projectId, 'paused', !this.state.projects[projectId-1].paused);
    }
    this.writeProvider.artistTeamToggleProjectIsPaused(projectId, this._projectAdminCallbacks());
  }
  artistTeamUpdateProjectImageURLInfo = (projectId, newIPFSCID, newIPFSCIDExt, useImageURLInGridView) => {
    if (!this.writeProvider) return;
    this.writeProvider.artistTeamUpdateProjectImageURLInfo(projectId, newIPFSCID, newIPFSCIDExt, useImageURLInGridView, this._projectAdminCallbacks());
  }
  artistTeamLockProjectContractOwnerUnlockProject = (projectId, newState) => {
    if (!this.writeProvider) return this._updateProjectField(projectId, 'locked', newState ? 'true' : 'false');
    this.writeProvider.artistTeamLockProjectContractOwnerUnlockProject(projectId, newState, {
      onLoading: (loading) => this.setState({ projectAdminLoading: loading }),
      onSuccess: () => this.loadBlockchainData(),
      onError: () => {},
    });
  }
  teamUpdateProjectCategory = (projectId, v) =>
    this._projectFieldWrite('teamUpdateProjectCategory', projectId, v, 'category', this._projectAdminCallbacks);
  artistTeamUpdateProjectScriptTransactionHash = (projectId, newTransactionHash) => {
    if (newTransactionHash === this.state.projects[projectId-1].scriptTransactionHash) return;
    if (!this.writeProvider) return this._updateProjectField(projectId, 'scriptTransactionHash', newTransactionHash);
    this.writeProvider.artistTeamUpdateProjectScriptTransactionHash(projectId, newTransactionHash, {
      onLoading: (loading) => this.setState({ adminLoading: loading, projectAdminLoading: loading }),
      onSuccess: () => {}, onError: () => {},
    });
  }
  artistTeamUpdateProjectScriptType = (projectId, v) =>
    this._projectFieldWrite('artistTeamUpdateProjectScriptType', projectId, v, 'scriptType', this._projectAdminCallbacks);
  teamUpdateFeaturedProject = (projectId) => {
    if (projectId === this.state.featuredProjectId) return;
    if (!this.writeProvider) return;
    this.writeProvider.teamUpdateFeaturedProject(projectId, {
      onLoading: (loading) => this.setState({ adminLoading: loading, projectAdminLoading: loading }),
      onSuccess: () => {}, onError: () => {},
    });
  }
  artistUpdateProjectAdditionalPayeeInfo = (projectId, beneficiary, percent) => {
    if (!this.writeProvider) return;
    this.writeProvider.artistUpdateProjectAdditionalPayeeInfo(projectId, beneficiary, percent, this._projectAdminCallbacks());
  }
  artistUpdateProjectArtistAddress = (projectId, newAddress) => {
    if (!this.writeProvider) return;
    this.writeProvider.artistUpdateProjectArtistAddress(projectId, newAddress, this._projectAdminCallbacks());
  }
  artistOwnerUpdateTokenWithMessage = (tokenId, message) => {
    if (message.length > 0) {
      if (!this.writeProvider) return;
      this.writeProvider.artistOwnerUpdateTokenWithMessage(tokenId, message, {
        onLoading: (loading) => this.setState({ loadingAddMessage: loading }),
        onSuccess: () => {}, onError: () => {},
      });
    }
  }

  /// ===== Write Operations End ====================


  /// ===== Click Handler Functions Start  ====================

  setSelectedProjectEdition = async (projectId, editionId) => {
    await this.loadProject(projectId);
    await this.setSelectedEdition(editionId);
  }

  setSelectedEditionMetadata = async (metadata) => {
    // console.log(`setSelectedEditionMetadata: ${metadata}`)
    if(metadata !== this.state.editionIdMetadata) {
      this.setState({
        editionIdMetadata: metadata,
      })
    }
  }

  setMetadataObject = async (metadataObject) => {
    // console.log("setMetadataObject: ", metadataObject)
    if(metadataObject !== this.state.metadataObject) {
      this.setState({
        metadataObject: metadataObject,
      })
    }
  }

  setViewImageURLInDetailView = async(input) => {
    this.setState({clientViewImageURLInDetailView: input});
  }

  // Called when IPFS is unavailable - switches to P5 live rendering
  onIPFSUnavailable = () => {
    console.log('[App] onIPFSUnavailable called, current state:', this.state.ipfsUnavailable);
    if (!this.state.ipfsUnavailable) {
      console.log('[App] IPFS unavailable, switching to live P5 rendering');
      this.setState({ ipfsUnavailable: true }, () => {
        console.log('[App] State updated, ipfsUnavailable is now:', this.state.ipfsUnavailable);
      });
    }
  }

  // Cap grid size for WebGL script types to avoid exceeding browser context limits
  getEffectiveMaxGridDimension() {
    const { projects, projectId } = this.state;
    if (!projects[projectId - 1]) return 4;
    const dim = projects[projectId - 1].maxGridDimension;
    if (["threejs", "vanillajs", "glsl"].includes(projects[projectId - 1].scriptType)) {
      return Math.min(dim, 2);
    }
    return dim;
  }

  // Toggle IPFS mode manually
  setIPFSMode = (useIPFS) => {
    this.setState({ ipfsUnavailable: !useIPFS });
  }

  /**
   * Wait until every edition on the current page has reported its metadata.
   *
   * Art scripts publish traits through console.log("metadata: ", ...), which
   * Grid collects. Some never report at all — a script may not emit any — so
   * this gives up after a while rather than hanging, and reports what it got.
   */
  _awaitPageMetadata = async (expected, page, totalPages, timeoutMs = 90000) => {
    const started = Date.now();
    let seen = 0;
    while (Date.now() - started < timeoutMs) {
      const have = this.state.metadataObject || {};
      seen = expected.filter(h => have[h]).length;
      this.setState({
        compileMetadataProgress:
          'page ' + page + ' of ' + totalPages + ' — ' + seen + '/' + expected.length + ' editions...',
      });
      if (seen >= expected.length) return seen;
      await new Promise(resolve => setTimeout(resolve, 400));
    }
    return seen;
  }

  compileMetadata = async () => {
    const { projects, projectId, projectTokens } = this.state;
    const project = projects[projectId - 1];
    if (!project || !projectTokens || projectTokens.length === 0) return;

    const maxGrid = this.getEffectiveMaxGridDimension();
    const perPage = maxGrid * maxGrid;
    const totalPages = Math.ceil(projectTokens.length / perPage);

    // Switch to live render mode (IPFS thumbnails don't emit metadata)
    const wasUsingIPFS = !this.state.ipfsUnavailable;
    // Ensure we're in grid view (not detail view) so editions render
    this.setState({
      editionId: null,
      ipfsUnavailable: true,
      compileMetadataProgress: 'page 1 of ' + totalPages + '...',
    });

    // Page through all grid pages, waiting for each page's editions to report.
    //
    // This used to wait a flat two seconds per page, which silently lost most of
    // a large project: a page of a 10x10 grid is a hundred sketches, and only a
    // handful have emitted their metadata by then. Waiting on the data instead
    // of the clock keeps the result complete whatever the grid size, and costs
    // nothing extra on small projects, which finish as soon as they are done.
    for (let page = 1; page <= totalPages; page++) {
      this.setState({ currentPage: page });
      const start = (page - 1) * perPage;
      const expected = projectTokens.slice(start, start + perPage).map(t => t.transactionHash);
      await this._awaitPageMetadata(expected, page, totalPages);
    }

    // Reset to page 1, compile data to localStorage
    const metadataObject = this.state.metadataObject || {};
    const tokens = {};
    projectTokens.forEach(t => {
      const meta = metadataObject[t.transactionHash]
        ? { ...metadataObject[t.transactionHash] } : null;
      if (meta) delete meta.transactionHash;
      tokens[t.tokenId] = {
        tokenId: t.tokenId,
        editionId: t.editionId,
        transactionHash: t.transactionHash,
        metadata: meta
      };
    });
    const data = {
      projectId: String(projectId),
      projectName: project.name || 'Project ' + projectId,
      tokens: tokens
    };
    try {
      localStorage.setItem('statsViewerData', JSON.stringify(data));
    } catch (e) {
      console.warn('Failed to store stats data:', e);
    }
    // Kept in state as well: the stats page clears the localStorage key once it
    // has read it, and the panel needs to write it again each time it mounts.
    this.setState({ statsData: data });
    // Count this project's editions, not everything rendered this session.
    // The session-wide tally reported a different number from the tab beside it
    // and, being a snapshot taken as the loop ended, could also lag late arrivals.
    const metaCount = Object.values(tokens).filter(t => t.metadata).length;
    this.setState({ currentPage: 1, compileMetadataProgress: 'done:' + metaCount, ipfsUnavailable: !wasUsingIPFS });
  }

  /**
   * A token was picked in the statistics charts — show that edition underneath.
   *
   * The dialog deliberately stays open. Picking tokens is usually done in a
   * run, comparing one against the next, and the grid is visible around the
   * panel — closing it after every click would undo the comparison being made.
   */
  selectEditionFromStats = (tokenId) => {
    const { projectTokens, projectId } = this.state;
    if (!projectTokens) return;
    const token = projectTokens.find(t => String(t.tokenId) === String(tokenId));
    if (!token) return;
    this.setSelectedProjectEdition(projectId, parseInt(token.editionId, 10));
  }

  /**
   * A trait value was selected in the charts — narrow the grid to the editions
   * that carry it. Matching is done here, from the metadata already collected,
   * so the charts only have to report which trait and value were chosen.
   */
  filterGridByTraits = (filters) => {
    const { projectTokens, metadataObject } = this.state;
    const pairs = Object.entries(filters || {});
    if (!pairs.length || !projectTokens) {
      this.setState({ traitFilter: null, currentPage: 1 });
      return;
    }
    const tokens = projectTokens.filter(t => {
      const meta = metadataObject && metadataObject[t.transactionHash];
      if (!meta) return false;
      return pairs.every(([trait, value]) => String(meta[trait]) === String(value));
    });
    this.setState({
      traitFilter: { pairs, tokens },
      editionId: null,
      currentPage: 1,
    });
  }

  clearTraitFilter = () => this.setState({ traitFilter: null, currentPage: 1 });

  // The wizard is launched from inside the about dialog, so close that first
  // rather than stacking one modal on another.
  launchWizard = () => {
    this.closeAboutPlatformModal();
    this.openWizardModal();
  }

  // Statistics are shown in the project modal now rather than a separate page,
  // so this only clears the progress note.
  openStatsViewer = () => {
    this.setState({ compileMetadataProgress: null });
  }

  setCurrentPage = async (page) => {
    // console.log(`setCurrentPage: ${page}`)
    if(page !== this.state.currentPage) {
      //this.setState({ loading: true})
      this.setState({currentPage: page})
      //this.setState({ loading: false })
    }
  }

  setSelectedEdition = async (editionId) => {
    if (this.dataProvider) {
      let editionIdEventHistoryData;

      let tokenId = null;
      try {
        tokenId = this.state.projectTokens[editionId-1].tokenId;
      } catch(error) { }

      let currentPage = this.state.currentPage;
      try {
        currentPage = Math.ceil(editionId/(this.getEffectiveMaxGridDimension()**2));
      } catch(error) { }

      // Update UI immediately, then fetch owner asynchronously
      this.setState({
        tokenId,
        ownerOfSelectedEdition: null,
        editionId,
        currentPage,
        editionIdEventHistoryData
      });

      // Fetch owner in background via provider
      try {
        const ownerOfSelectedEdition = await this.dataProvider.getOwnerOfToken(this.state.projectTokens[editionId-1].tokenId);
        // ownersCapturedAt is only set by ArchiveProvider; a live chain read has
        // no "as of" date because it is current by definition.
        this.setState({
          ownerOfSelectedEdition,
          ownerAsOf: this.dataProvider.ownersCapturedAt || null,
        });
      } catch(error) { }

    } else {
      this.setState({
        ownerOfSelectedEdition: null,
        editionId: editionId,
        editionIdEventHistoryData: null,
      })
    }
  }

  resetSelectedEdition = async () => {
    // console.log(`resetSelectedEdition`)
    //this.props.history.push(`/${this.state.projectId}`)
    //await this.loadProject(this.state.projectId);
    this.setState({
      ownerOfSelectedEdition: null,
      editionIdEventHistoryData: null,
      editionId: null,
      tokenId: null,
    })
    //window.location.reload()
  }

  setProjectId(projectId) {
    // console.log("Selected Project: ", projectId);
    if(projectId !== this.state.projectId) {
      this.setState({projectId});
      this.props.history.push(`/${projectId}`);
      this.loadBlockchainData();
      window.location.reload();
    } else {
      this.closeAboutPlatformModal();
    }
  }

  onProjectChange(e) {
    // console.log("Selected Project: ", e.target.value);
    this.setState({projectId: e.target.value});
    this.props.history.push(`/${e.target.value}`);
    this.loadBlockchainData();
    window.location.reload();
  }

  onSubmitMint(e) {
    e.preventDefault()
    this.mint(this.state.projectId)
  }

  /// ===== Click Handler Functions End  ====================

  toggleMuseumMode = () => {
    if (this.museumRef.current) this.museumRef.current.startDefault();
  }

  render() {

const { account, userIsAdmin, userIsContractOwner, userIsPayee, userIsProjectArtist,

        curator, curatorPercent, beneficiary, beneficiaryPercent, secondaryRoyaltyPercent, projectRoyaltyAddress,
        contractOwner, teammembers,

        loading, loadingDescription, projectCreateLoading, projectMintLoading, adminLoading, projectAdminLoading, featuredProjectId,
        immutablesURI, immutablesWEB, useMetadataServer, contractBalance, artistPercent, isConnectedToADeployedToNetwork,

        contract, projects, projectId, platform, editionId, projectTokens, projectIsSoldOut, editionIdMetadata, metadataObject, ownerOfSelectedEdition, ownerAsOf, tokenId,

        projectPricePerEditionInEth, projectArtistAddress, projectIdToArtistAddress, projectCurrentEditions,

        projectFeeInEth, artistScreeningEnabled, userIsAuthorizedArtist, authorizedArtists,
        projectAdditionalPayee, projectAdditionalPayeePercent,

        royaltyContractBalance,

        projectIdToImageURLBase, projectIdToImageURLExt, projectIdUseImageURLInGridView, clientViewImageURLInDetailView,

        mostRecentMintEvent,

        script, projectCSSStyle,

        loadingAddMessage, fromBlock,

        isAdminModalOpen, isProjectAdminModalOpen, isWalletOpen, isWizardOpen, isProjectModalOpen, isAboutPlatformOpen, isMintOpen, isMintSuccessOpen, isChainModalOpen, isCreateProjectOpen, isSelectProjectOpen, isZoraModalOpen
  } = this.state;

    const dataValue = {
      projects, projectId, projectIdToArtistAddress, projectArtistAddress,
      projectTokens, projectCurrentEditions, projectIsSoldOut,
      projectPricePerEditionInWei: this.state.projectPricePerEditionInWei,
      projectPricePerEditionInEth, projectAdditionalPayee, projectAdditionalPayeePercent,
      projectRoyaltyAddress, royaltyContractBalance,
      script, warnScriptPosterArtistMismatch: this.state.warnScriptPosterArtistMismatch,
      warnScriptPageProjectNameMismatch: this.state.warnScriptPageProjectNameMismatch,
      projectIdToImageURLBase, projectIdToImageURLExt, projectIdUseImageURLInGridView,
      clientViewImageURLInDetailView, ipfsUnavailable: this.state.ipfsUnavailable,
      tokenId, editionId, ownerOfSelectedEdition, editionIdEventHistoryData: this.state.editionIdEventHistoryData,
      editionIdMetadata, metadataObject,
      currentPage: this.state.currentPage,
      platform, contract, artistPercent, secondaryRoyaltyPercent, featuredProjectId, projectFeeInEth,
      curator, curatorPercent, beneficiary, beneficiaryPercent, contractBalance,
      loading, loadingDescription,
    };

    const connectionValue = {
      account, networkId: this.state.networkId, deployedNetwork: this.state.deployedNetwork,
      isConnectedToADeployedToNetwork,
      userIsAdmin, userIsContractOwner, userIsPayee,
      userIsAuthorizedArtist, userIsProjectArtist, userHasAProject: this.state.userHasAProject,
      contractOwner, artistScreeningEnabled,
      immutablesWEB, immutablesURI, useMetadataServer,
      teammembers, authorizedArtists,
    };

    const writeValue = this.writeProvider ? {
      createNewProject: this.createNewProject,
      mint: this.mint,
      onSubmitMint: this.onSubmitMint,
      contractOwnerUpdateWebsiteUrl: this.contractOwnerUpdateWebsiteUrl,
      contractOwnerUpdateAPIURL: this.contractOwnerUpdateAPIURL,
      contractOwnerUpdateUseMetadataServer: this.contractOwnerUpdateUseMetadataServer,
      contractOwnerUpdateGlobalSecondaryRoyaltyPercent: this.contractOwnerUpdateGlobalSecondaryRoyaltyPercent,
      contractOwnerUpdateProjectFee: this.contractOwnerUpdateProjectFee,
      contractOwnerUpdateArtistPercent: this.contractOwnerUpdateArtistPercent,
      contractOwnerAddTeammember: this.contractOwnerAddTeammember,
      contractOwnerRemoveTeammember: this.contractOwnerRemoveTeammember,
      teamToggleArtistScreeningEnabled: this.teamToggleArtistScreeningEnabled,
      teamAddAuthorizedArtist: this.teamAddAuthorizedArtist,
      teamRemoveAuthorizedArtist: this.teamRemoveAuthorizedArtist,
      contractOwnerUpdateCuratorAddressAndPercent: this.contractOwnerUpdateCuratorAddressAndPercent,
      contractOwnerUpdateBeneficiaryAddressAndPercent: this.contractOwnerUpdateBeneficiaryAddressAndPercent,
      adminwithdraw: this.adminwithdraw,
      releaseRoyaltiesForProject: this.releaseRoyaltiesForProject,
      artistTeamUpdateProjectName: this.artistTeamUpdateProjectName,
      artistTeamUpdateProjectDescription: this.artistTeamUpdateProjectDescription,
      artistTeamUpdateArtistName: this.artistTeamUpdateArtistName,
      artistTeamUpdateProjectPricePerToken: this.artistTeamUpdateProjectPricePerToken,
      artistTeamUpdateProjectMaxEditions: this.artistTeamUpdateProjectMaxEditions,
      artistTeamUpdateProjectMaxGridDimension: this.artistTeamUpdateProjectMaxGridDimension,
      teamToggleProjectIsActive: this.teamToggleProjectIsActive,
      artistTeamToggleProjectIsPaused: this.artistTeamToggleProjectIsPaused,
      artistTeamUpdateProjectImageURLInfo: this.artistTeamUpdateProjectImageURLInfo,
      artistTeamLockProjectContractOwnerUnlockProject: this.artistTeamLockProjectContractOwnerUnlockProject,
      teamUpdateProjectCategory: this.teamUpdateProjectCategory,
      artistTeamUpdateProjectScriptTransactionHash: this.artistTeamUpdateProjectScriptTransactionHash,
      artistTeamUpdateProjectScriptType: this.artistTeamUpdateProjectScriptType,
      teamUpdateFeaturedProject: this.teamUpdateFeaturedProject,
      artistUpdateProjectAdditionalPayeeInfo: this.artistUpdateProjectAdditionalPayeeInfo,
      artistUpdateProjectArtistAddress: this.artistUpdateProjectArtistAddress,
      artistOwnerUpdateTokenWithMessage: this.artistOwnerUpdateTokenWithMessage,
      // Loading state for write operations
      projectCreateLoading, projectMintLoading, adminLoading, projectAdminLoading,
      loadingAddMessage,
    } : null;

    return (
      <DataContext.Provider value={dataValue}>
      <ConnectionContext.Provider value={connectionValue}>
      <WriteContext.Provider value={writeValue}>
      <div>
      { (loading) ? (
          <>
          <div id="loader" className="loader-screen">
            {/*
              The platform's own mark, shimmering while the chain is read. The
              glyphs are decorative -- the name below says what this is -- so
              they are hidden from screen readers and the status line carries
              the actual progress.
            */}
            <div className="loader-mark" aria-hidden="true">][</div>
            <h3 className="loader-name font-display">{this.state.platform.name}</h3>
            <div className="loader-status font-display" role="status" aria-live="polite">
              {loadingDescription}
            </div>

            </div>
            {/* Outside the overlay, so the wallet stays reachable while the
                status line is asking for one. */}
            {this.getPlatformNavbar()}
          </>
          ) : (
          <div>
             {!this.state.museumModeActive && this.getPlatformNavbar()}
            <MuseumExhibition ref={this.museumRef} show={this.state.isMuseumSettingsOpen}
              onHide={() => this.setState({ isMuseumSettingsOpen: false })}
              projects={projects} projectId={projectId} networkId={this.state.networkId}
              provider={this.dataProvider}
              currentTokens={projectTokens} currentScript={script} currentCSS={projectCSSStyle}
              currentDetails={{ projectIdToImageURLBase, projectIdToImageURLExt,
                projectIdUseImageURLInGridView, ipfsUnavailable: this.state.ipfsUnavailable }}
              onActiveChange={(active, openSettings) => this.setState({ museumModeActive: active,
                ...(openSettings ? { isMuseumSettingsOpen: true } : {}) })} />
            <ChainModal
              isChainModalOpen={isChainModalOpen} closeChainModal={this.closeChainModal}
            />
            <WizardModal
              show={isWizardOpen}
              onHide={this.closeWizardModal}
            />

            <WalletModal
              show={isWalletOpen}
              onHide={this.closeWalletModal}
              onConnect={this.handleWalletConnect}
              platform={platform}
            />
            <AboutPlatformModal
              openWizardModal={this.launchWizard}
              isAboutPlatformOpen={isAboutPlatformOpen}
              platform={platform} contract={contract} getProjectScript={this.getProjectScript}
              closeAboutPlatformModal={this.closeAboutPlatformModal}
              setSelectedProjectEdition={this.setSelectedProjectEdition}
              getUserEditionsEnumerable={this.getUserEditionsEnumerable}
              openCreateProjectModal={this.openCreateProjectModal}
              userIsAuthorizedArtist={userIsAuthorizedArtist}
              artistScreeningEnabled={artistScreeningEnabled}
              projects={projects}
              setProjectId={this.setProjectId}
            />
             { (isConnectedToADeployedToNetwork) ? (
                <div>
                  {!this.state.museumModeActive && <div>
                  <div className="row">
                    {this.getTraitFilterNotice()}
                    {this.getGrid()}
                  </div>
                  </div>}

                <AdminModal
                  platform={platform} contract={contract} isAdminModalOpen={isAdminModalOpen} adminLoading={adminLoading} useMetadataServer={useMetadataServer}

                  immutablesWEB={immutablesWEB} immutablesURI={immutablesURI}
                  contractOwnerUpdateWebsiteUrl={this.contractOwnerUpdateWebsiteUrl}
                  contractOwnerUpdateAPIURL={this.contractOwnerUpdateAPIURL}
                  contractOwnerUpdateUseMetadataServer={this.contractOwnerUpdateUseMetadataServer}

                  projectFeeInEth={projectFeeInEth}
                  contractOwnerUpdateProjectFee={this.contractOwnerUpdateProjectFee}
                  artistPercent={artistPercent}
                  contractOwnerUpdateArtistPercent={this.contractOwnerUpdateArtistPercent}

                  secondaryRoyaltyPercent={secondaryRoyaltyPercent}
                  contractOwnerUpdateGlobalSecondaryRoyaltyPercent = {this.contractOwnerUpdateGlobalSecondaryRoyaltyPercent}

                  contractOwnerAddTeammember={this.contractOwnerAddTeammember}
                  contractOwnerRemoveTeammember={this.contractOwnerRemoveTeammember}

                  userIsPayee={userIsPayee}
                  userIsContractOwner={userIsContractOwner}
                  userIsAdmin={userIsAdmin}
                  getTeammembers={this.getTeammembers}
                  teammembers={teammembers}

                  artistScreeningEnabled={artistScreeningEnabled}
                  teamToggleArtistScreeningEnabled={this.teamToggleArtistScreeningEnabled}
                  teamAddAuthorizedArtist={this.teamAddAuthorizedArtist}
                  teamRemoveAuthorizedArtist={this.teamRemoveAuthorizedArtist}
                  getAuthorizedArtists={this.getAuthorizedArtists}
                  authorizedArtists={authorizedArtists}

                  featuredProjectId={featuredProjectId}
                  teamUpdateFeaturedProject={this.teamUpdateFeaturedProject}

                  artistTeamUpdateProjectScriptTransactionHash={this.artistTeamUpdateProjectScriptTransactionHash}

                  curator={curator} curatorPercent={curatorPercent}
                  contractOwnerUpdateCuratorAddressAndPercent={this.contractOwnerUpdateCuratorAddressAndPercent}

                  beneficiary={beneficiary} beneficiaryPercent={beneficiaryPercent}
                  contractOwnerUpdateBeneficiaryAddressAndPercent={this.contractOwnerUpdateBeneficiaryAddressAndPercent}

                  contractBalance={contractBalance}
                  adminwithdraw={this.adminwithdraw}

                  closeAdminModal={this.closeAdminModal}
                />

                <ProjectAdminModal
                  contract={contract}
                  isProjectAdminModalOpen={isProjectAdminModalOpen} projectAdminLoading={projectAdminLoading} adminLoading={adminLoading}
                  userIsAdmin={userIsAdmin} contractOwner={contractOwner} userIsProjectArtist={userIsProjectArtist}
                  platform={platform} projects={projects} projectId={projectId} contractBalance={contractBalance}
                  beneficiary={beneficiary} beneficiaryPercent={beneficiaryPercent} projectPricePerEditionInEth={projectPricePerEditionInEth}

                  projectArtistAddress={projectArtistAddress}
                  artistTeamUpdateProjectName={this.artistTeamUpdateProjectName}
                  artistTeamUpdateArtistName={this.artistTeamUpdateArtistName}
                  artistTeamUpdateProjectDescription={this.artistTeamUpdateProjectDescription}
                  artistTeamUpdateProjectPricePerToken={this.artistTeamUpdateProjectPricePerToken}
                  artistTeamUpdateProjectMaxEditions={this.artistTeamUpdateProjectMaxEditions}
                  artistTeamUpdateProjectMaxGridDimension={this.artistTeamUpdateProjectMaxGridDimension}
                  teamToggleProjectIsActive={this.teamToggleProjectIsActive}
                  teamUpdateProjectCategory={this.teamUpdateProjectCategory}
                  artistTeamToggleProjectIsPaused={this.artistTeamToggleProjectIsPaused}
                  artistTeamLockProjectContractOwnerUnlockProject={this.artistTeamLockProjectContractOwnerUnlockProject}

                  projectTokens={projectTokens}
                  projectCurrentEditions={projectCurrentEditions}

                  artistTeamUpdateProjectScriptTransactionHash={this.artistTeamUpdateProjectScriptTransactionHash}
                  artistTeamUpdateProjectScriptType={this.artistTeamUpdateProjectScriptType}

                  projectAdditionalPayee={projectAdditionalPayee}
                  projectAdditionalPayeePercent={projectAdditionalPayeePercent}
                  artistUpdateProjectAdditionalPayeeInfo={this.artistUpdateProjectAdditionalPayeeInfo}

                  artistUpdateProjectArtistAddress={this.artistUpdateProjectArtistAddress}

                  royaltyContractBalance={royaltyContractBalance}
                  releaseRoyaltiesForProject={this.releaseRoyaltiesForProject}

                  secondaryRoyaltyPercent = {secondaryRoyaltyPercent}
                  projectRoyaltyAddress = {projectRoyaltyAddress}
                  contractOwnerUpdateGlobalSecondaryRoyaltyPercent = {this.contractOwnerUpdateGlobalSecondaryRoyaltyPercent}

                  projectIdToImageURLBase = {projectIdToImageURLBase}
                  projectIdToImageURLExt = {projectIdToImageURLExt}
                  artistTeamUpdateProjectImageURLInfo = {this.artistTeamUpdateProjectImageURLInfo}
                  projectIdUseImageURLInGridView={projectIdUseImageURLInGridView}

                  projectCSSStyle={projectCSSStyle}
                  metadataObject={metadataObject}
                  compileMetadata={this.compileMetadata}
                  compileMetadataProgress={this.state.compileMetadataProgress} statsData={this.state.statsData} onSelectEdition={this.selectEditionFromStats} onFilterChange={this.filterGridByTraits}
                  openStatsViewer={this.openStatsViewer}
                  closeProjectAdminModal={this.closeProjectAdminModal}
                />

                <ProjectModal
                  show={isProjectModalOpen}
                  onHide={this.closeProjectModal}
                  account={account} userIsAdmin={userIsAdmin}
                  projects={projects} projectId={projectId} editionId={editionId}
                  projectTokens={projectTokens} projectIdToArtistAddress={projectIdToArtistAddress}
                  onProjectChange={this.onProjectChange}
                  selectedProjectInformation={this.getSelectedProjectInformation()}
                  contract={contract} platform={platform} sourceType={this.state.sourceType} cacheGeneratedAt={this.state.cacheGeneratedAt}
                  script={script} pagePosts={this.state.pagePosts}
                  metadataObject={metadataObject}
                  compileMetadata={this.compileMetadata}
                  compileMetadataProgress={this.state.compileMetadataProgress} statsData={this.state.statsData} onSelectEdition={this.selectEditionFromStats} onFilterChange={this.filterGridByTraits}
                  openStatsViewer={this.openStatsViewer}
                  ownerOfSelectedEdition={ownerOfSelectedEdition} ownerAsOf={ownerAsOf}
                  projectArtistAddress={projectArtistAddress}
                  tokenId={tokenId}
                  clientViewImageURLInDetailView={clientViewImageURLInDetailView && !this.state.ipfsUnavailable}
                  artistOwnerUpdateTokenWithMessage={this.artistOwnerUpdateTokenWithMessage}
                  loadingAddMessage={loadingAddMessage}
                  fromBlock={fromBlock}
                  getAbbreviatedHash={this.getAbbreviatedHash}
                />

                <SelectProjectModal
                  isSelectProjectOpen={isSelectProjectOpen}
                  closeSelectProjectModal={this.closeSelectProjectModal}
                  contract={contract}
                  projects={projects}
                  projectId={projectId}
                  platform={platform}
                  onProjectChange={this.onProjectChange}
                />

                <ProjectCreationModal
                  isCreateProjectOpen={isCreateProjectOpen}
                  closeCreateProjectModal={this.closeCreateProjectModal}
                  projectCreateLoading={projectCreateLoading}
                  createNewProject={this.createNewProject}
                  platform={platform}
                  contract={contract}
                  artistPercent={artistPercent}
                />

                <MintModal
                  account={account} projectMintLoading={projectMintLoading} isMintOpen={isMintOpen} projectIsSoldOut={projectIsSoldOut}
                  closeMintModal={this.closeMintModal} onSubmitMint={this.onSubmitMint}
                  userIsAdmin={userIsAdmin}
                  selectedProjectInformation={this.getSelectedProjectInformation()} projects={projects} projectId={projectId} platform={platform} contract={contract}
                  projectPricePerEditionInEth={projectPricePerEditionInEth} projectArtistAddress={projectArtistAddress} artistPercent={artistPercent}
                  projectAdditionalPayee={projectAdditionalPayee} projectAdditionalPayeePercent={projectAdditionalPayeePercent}
                  beneficiaryPercent={beneficiaryPercent} beneficiary={beneficiary} curator={curator} curatorPercent={curatorPercent}
                  getAbbreviatedHash={this.getAbbreviatedHash}
                  pagePosts={this.state.pagePosts}
                  warnScriptPosterArtistMismatch={this.state.warnScriptPosterArtistMismatch}
                  scriptPoster={this.state.scriptPoster}
                  projectRoyaltyAddress={this.state.projectRoyaltyAddress}
                />

                <MintSuccessModal
                  platform={platform}
                  contract={contract}
                  account={account}
                  isMintSuccessOpen={isMintSuccessOpen} closeMintSuccessModal={this.closeMintSuccessModal}
                  projects={projects} projectId={projectId} script={script}
                  projectTokens={projectTokens}
                  mostRecentMintEvent={mostRecentMintEvent}
                />

                {this.state.sourceType === 'blockchain' && (
                <ZoraModal
                  account={account}
                  isZoraModalOpen={isZoraModalOpen}
                  platform={platform} contract={contract}
                  closeZoraModal={this.closeZoraModal}
                  setSelectedEdition={this.setSelectedEdition}
                  resetSelectedEdition={this.resetSelectedEdition}
                  getUserEditionsEnumerable={this.getUserEditionsEnumerable}


                  ownerOfSelectedEdition={ownerOfSelectedEdition} ownerAsOf={ownerAsOf}
                  projectId={projectId} editionId={editionId} projectTokens={projectTokens}
                  projects={projects}
                  tokenId={tokenId}
                />
                )}

                </div>
              ) : (
                <div>
                  <br/>
                  <br/>
                  <br/>
                  <br/>
                  <center>
                    <h3 style={{ color: 'black' }}>please connect to a network with a deployed contract. (mainnet or rinkeby)</h3>
                    <br/>
                    <Button onClick={this.openAboutPlatformModal} variant="secondary" size='lg'>what is immutables.art?</Button>
                    </center>
                  <br/>
                </div>
              ) }
            </div>
          )}

          {(this.state.projectCSSStyle && !this.state.museumModeActive) ? (
            <div>
            <style>
              {/* Confined to the app and to dialogs that are not marked plain,
                  so a project themes the art and its own screens without
                  reaching the trading and administration panels. */}
              {scopeCss(this.state.projectCSSStyle, '#root')}
              {scopeCss(this.state.projectCSSStyle, '.modal:not(.dock-plain)', { dropRootRules: true })}
              {/* And once more with dialog rules re-aimed at the panels that
                  replaced those dialogs, so a themed project stays themed. */}
              {scopeCss(this.state.projectCSSStyle, '#root', { translate: PANEL_FROM_MODAL })}
            </style>
            </div>
          ) : ("")}


         </div>
      </WriteContext.Provider>
      </ConnectionContext.Provider>
      </DataContext.Provider>
    );
  }
}

export default App;
